import React, { useMemo } from 'react';
import { useTheme } from '../../theme';

type BrandNameProps = {
  text?: string;
  className?: string;
  highlight?: string;
};

function escapeRegExp(input: string): string {
  return input.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

export const BrandName: React.FC<BrandNameProps> = ({ text = '', className = '', highlight = 'AI' }) => {
  const { branding } = useTheme();

  const parts = useMemo(() => {
    const value = String(text || '');
    const needle = String(highlight || '').trim();

    if (!value || !needle) {
      return [{ value, isHighlight: false }];
    }

    const re = new RegExp(escapeRegExp(needle), 'gi');
    const result: Array<{ value: string; isHighlight: boolean }> = [];

    let lastIndex = 0;
    let match: RegExpExecArray | null;
    while ((match = re.exec(value)) !== null) {
      const start = match.index;
      const end = start + match[0].length;

      if (start > lastIndex) {
        result.push({ value: value.slice(lastIndex, start), isHighlight: false });
      }

      result.push({ value: value.slice(start, end), isHighlight: true });
      lastIndex = end;
    }

    if (lastIndex < value.length) {
      result.push({ value: value.slice(lastIndex), isHighlight: false });
    }

    return result.length > 0 ? result : [{ value, isHighlight: false }];
  }, [text, highlight]);

  return (
    <span className={className}>
      {parts.map((p, idx) =>
        p.isHighlight ? (
          <span
            key={idx}
            className="font-extrabold bg-clip-text text-transparent"
            style={{ backgroundImage: `linear-gradient(to right, ${branding.primaryColor}, ${branding.primaryColorHover})` }}
          >
            {p.value}
          </span>
        ) : (
          <span key={idx}>{p.value}</span>
        )
      )}
    </span>
  );
};

export default BrandName;
